import { styled } from "@mui/material";

import { Box, Text } from "shipnow-mercurio";

const Description = styled(Text)({
  margin: "8px auto 0 auto",
  maxWidth: "400px",
});

const ImageWrapper = styled("img")((props) => ({
  maxWidth: props.width || "360px",
  padding: "50px 16px 0 16px",
  width: "100%",
}));

const Wrapper = styled(Box)({
  textAlign: "center",
  margin: "auto",
});

export const Styles = {
  Description,
  ImageWrapper,
  Wrapper,
};
